// eslint-ignore
export default 
`<Input label="Text" />
<Input type="number" label="Number"/>
<Input type="email" label="Email" />
<Input type="password" label="Password" />
<Input type="search" label="Search" />
<Input type="url" label="URL" />
<Input type="tel" label="Tel" />
<Input type="date" label="Date"/>
<Input type="time" label="Time"/>
<Input type="range" label="Range" />
<Input type="color" label="Color" />


export default {
    components: { Input }
}`;